import React from "react";
import { ChevronDown } from "lucide-react";

export default function HeroSection() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-start overflow-hidden"
    >
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#1a2f2a] via-[#0f1f1b] to-[#0B1211]" />

      {/* Subtle radial glow */}
      <div className="absolute top-1/3 left-1/4 w-[600px] h-[600px] bg-[#34D399]/5 rounded-full blur-[150px] pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-32 pb-20 w-full">
        {/* Tagline label */}
        <div
          data-testid="hero-tagline"
          className="inline-block mb-8 opacity-0 animate-slide-up"
        >
          <span className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.1em] sm:tracking-[0.25em] text-[#34D399]/80 border border-[#34D399]/20 px-3 sm:px-4 py-2 rounded-full bg-[#34D399]/5 whitespace-nowrap">
            Quantum-Driven Financial Advisory
          </span>
        </div>

        {/* Main headline */}
        <h1
          data-testid="hero-headline"
          className="text-5xl sm:text-6xl lg:text-8xl font-bold tracking-tight text-[#F0FDF4] leading-[0.95] mb-6 opacity-0 animate-slide-up delay-200"
        >
          Financial
          <br />
          Intelligence.
        </h1>

        <h2
          data-testid="hero-subheadline"
          className="text-2xl sm:text-3xl lg:text-4xl font-light tracking-tight text-[#94A3B8] mb-10 opacity-0 animate-slide-up delay-300"
        >
          Redefined by Quantum Mechanics.
        </h2>

        {/* Description */}
        <p
          data-testid="hero-description"
          className="max-w-xl text-base md:text-lg leading-relaxed text-[#94A3B8] mb-12 opacity-0 animate-slide-up delay-400"
        >
          Strategic advisory in quantum computing and quantitative finance.
          Transforming algorithmic complexity into competitive advantage.
        </p>

        {/* CTA */}
        <div className="flex flex-col sm:flex-row items-start gap-4 opacity-0 animate-slide-up delay-500">
          <a
            href="mailto:javier@cybersyn.systems?subject=Consultation%20Request"
            data-testid="hero-cta"
            className="bg-[#34D399] text-[#064E3B] font-semibold text-base px-10 py-4 rounded-full cta-glow hover:bg-[#10B981] transition-all inline-flex items-center gap-2"
          >
            Schedule a Consultation
          </a>
          <a
            href="#about"
            data-testid="hero-learn-more"
            className="border border-[#34D399]/30 text-[#34D399] hover:bg-[#34D399]/10 px-10 py-4 rounded-full transition-all backdrop-blur-sm font-medium text-base inline-flex items-center gap-2"
          >
            Learn More
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 scroll-indicator opacity-0 animate-fade-in delay-600">
        <a href="#about" className="text-[#34D399]/40 hover:text-[#34D399] transition-colors">
          <ChevronDown size={28} />
        </a>
      </div>
    </section>
  );
}
